export const basisShortcut = () => {
  const component: HTMLElement = document.querySelector('[is="basis-shortcut"');
  if (!component) return;

  const handleScrollTrigger = () => {
    const links: HTMLAnchorElement[] = Array.from(
      component.querySelectorAll('a')
    );

    links.forEach((link) => {
      link.addEventListener('click', (e: MouseEvent) => {
        const targetId = link.getAttribute('href').replace('#', '');
        const targetElement = document.getElementById(targetId);
        if (!targetElement) return;

        e.preventDefault();
        targetElement.tabIndex = -1;
        targetElement.focus();
      });
    });
  };

  handleScrollTrigger();
};
